import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { auth } from '../services/api';
import { useStore } from '../store';

const MODULES = [
  { id: 'school',     label: 'School',     color: '#6366f1', icon: '◬' },
  { id: 'hospital',   label: 'Hospital',   color: '#ef4444', icon: '◎' },
  { id: 'pos',        label: 'POS',        color: '#10b981', icon: '◈' },
  { id: 'restaurant', label: 'Restaurant', color: '#f97316', icon: '◫' },
  { id: 'hotel',      label: 'Hotel',      color: '#8b5cf6', icon: '⬡' },
  { id: 'ngo',        label: 'NGO',        color: '#f59e0b', icon: '◉' },
];

export default function LoginScreen() {
  const nav = useNavigate();
  const { setUser, setToken, setModule } = useStore();
  const [form, setForm] = useState({ email: '', password: '' });
  const [mod, setMod] = useState('school');
  const [loading, setLoading] = useState(false);
  const selectedMod = MODULES.find(m => m.id === mod);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await auth.login(form);
      setToken(res.token || res.access_token);
      setUser(res.user || { email: form.email });
      setModule(mod);
      toast.success('Welcome to Cognira ERP!');
      nav('/app');
    } catch (err) {
      // Demo mode — allow offline login
      if (!navigator.onLine || err.message.includes('unavailable')) {
        setToken('offline_token_' + Date.now());
        setUser({ email: form.email || 'admin@cognira.vgo' });
        setModule(mod);
        toast.success('Connected (Offline mode)');
        nav('/app');
      } else {
        toast.error(err.message || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a12',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ width: 420, padding: '0 24px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 20,
            background: `linear-gradient(135deg, ${selectedMod?.color||'#6366f1'}, #8b5cf6)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, color: '#fff', margin: '0 auto 16px'
          }}>{selectedMod?.icon || 'C'}</div>
          <div style={{ fontSize: 26, fontWeight: 900, color: '#fff' }}>Cognira ERP</div>
          <div style={{ fontSize: 12, color: '#555', marginTop: 4 }}>by VGO Global</div>
        </div>

        {/* Module selector */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, color: '#555', marginBottom: 8, letterSpacing: 1 }}>
            SELECT MODULE
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {MODULES.map(m => (
              <button key={m.id} onClick={() => setMod(m.id)} style={{
                padding: '7px 14px',
                background: mod === m.id ? m.color + '22' : '#12121f',
                border: `1px solid ${mod === m.id ? m.color : '#1e1e3a'}`,
                borderRadius: 20,
                color: mod === m.id ? m.color : '#555',
                fontSize: 12, fontWeight: mod === m.id ? 600 : 400,
                cursor: 'pointer'
              }}>{m.icon} {m.label}</button>
            ))}
          </div>
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 5 }}>
              Email
            </label>
            <input type="email" placeholder="admin@school.com"
              value={form.email} onChange={e => setForm({...form, email: e.target.value})}
              style={{
                width: '100%', background: '#12121f',
                border: '1px solid #1e1e3a', borderRadius: 12,
                padding: '13px 16px', color: '#fff', fontSize: 14,
                outline: 'none', boxSizing: 'border-box'
              }} />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 5 }}>
              Password
            </label>
            <input type="password" placeholder="••••••••"
              value={form.password} onChange={e => setForm({...form, password: e.target.value})}
              style={{
                width: '100%', background: '#12121f',
                border: '1px solid #1e1e3a', borderRadius: 12,
                padding: '13px 16px', color: '#fff', fontSize: 14,
                outline: 'none', boxSizing: 'border-box'
              }} />
          </div>

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '15px',
            background: loading ? '#333' : `linear-gradient(135deg, ${selectedMod?.color||'#6366f1'}, #8b5cf6)`,
            border: 'none', borderRadius: 14,
            color: '#fff', fontSize: 15, fontWeight: 700,
            cursor: loading ? 'not-allowed' : 'pointer'
          }}>
            {loading ? 'Signing in...' : `Open ${selectedMod?.label} ERP`}
          </button>
        </form>

        <div style={{
          textAlign: 'center', marginTop: 20,
          padding: '12px', background: '#12121f',
          borderRadius: 10, border: '1px solid #1e1e3a'
        }}>
          <span style={{ fontSize: 12, color: '#555' }}>
            ◉ Works offline · Auto-syncs when online
          </span>
        </div>
      </div>
    </div>
  );
}
